module.exports = __webpack_public_path__ + "img/Gruppe 2467.9f7c0146.svg";